import Vue from 'vue'
import VueRouter from 'vue-router'
import layout from '../common/views/layout/Layout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: "/login",
    name: "login",
    component: () => import("../components/pages/Login.vue")
  },
  {
    path: '/',
    component: () => import('../common/views/layout/Layout.vue'),
    redirect: '/matchData',
    children: [
      {
        path: '/matchData',
        name: 'matchData',
        component: () => import('../views/matchData/matchData.vue'),
        meta: { title: '控制台' },
      },
    ]
  },
  {
    path: 'Marketing',
    redirect: '/Marketing/Marketing',
    component: layout,
    children: [
      {
        path: '/Marketing',
        name: 'Marketing',
        component: () => import('../views/Marketing/Marketing.vue'),
        meta: { title: '营销话术' },
      },
    ]
  },
  {
    path: 'Settlement',
    redirect: '/Settlement/Settlement',
    component: layout,
    children: [
      {
        path: '/Settlement',
        name: 'Settlement',
        component: () => import('../views/Settlement/Settlement.vue'),
        meta: { title: '营销话术' },
      },
    ]
  },
  {
    path: '/',
    component: () => import('../common/views/layout/Layout.vue'),
    redirect: '/InfoList',
    children: [
      {
        path: '/InfoList',
        name: 'infoList',
        component: () => import('../views/matchInfo/InfoList.vue'),
        meta: { title: '赛事信息' },
      },
    ]
  },
  {
    path: '/matchContest',
    redirect: '/matchContest/MatchContest',
    component: layout,
    children: [
      {
        path: '/MatchContest',
        name: 'matchContest',
        component: () => import('../views/matchContest/MatchContest.vue'),
        meta: { title: '赛事规格' },
      },
    ]
  },
  {
    path: '/matchIntroduce',
    redirect: '/matchIntroduce/MatchIntroduce',
    component: layout,
    children: [
      {
        path: '/MatchIntroduce',
        name: 'matchIntroduce',
        component: () => import('../views/matchIntroduce/MatchIntroduce.vue'),
        meta: { title: '赛事介绍' },
      },
    ]
  },
  {
    path: '/matchGroup',
    redirect: '/matchGroup/GroupLists',
    component: layout,
    children: [
      {
        path: '/GroupLists',
        name: 'matchGroup',
        component: () => import('../views/matchGroup/GroupLists.vue'),
        meta: { title: '组别管理' },
      },
    ]
  },
  {
    path: '/teamManage',
    redirect: '/teamManage/TeamControl',
    component: layout,
    children: [
      {
        path: '/TeamControl',
        name: 'teamControl',
        component: () => import('../views/teamManage/TeamControl.vue'),
        meta: { title: '球队管理' },
      },
    ]
  },
  {
    path: '/playerManage',
    redirect: '/teamList/TeamList',
    component: layout,
    children: [
      {
        path: '/TeamList',
        name: 'teamList',
        component: () => import('../views/playerManage/TeamList.vue'),
        meta: { title: '球队展示' },
      },
      {
        path: '/PlayerMange',
        name: 'playerMange',
        component: () => import('../views/playerManage/PlayerMange.vue'),
        meta: { title: '球员管理' },
      },

    ]
  },
  {
    path: '/refereeManage',
    redirect: '/refereeManage/RefereeManage',
    component: layout,
    children: [
      {
        path: '/RefereeManage',
        name: 'refereeManage',
        component: () => import('../views/refereeManage/RefereeManage.vue'),
        meta: { title: '裁判管理' },
      },
    ]
  },
  {
    path: '/matchCourse',
    redirect: '/matchCourse/MatchManage',
    component: layout,
    children: [
      {
        path: '/MatchManage',
        name: 'matchManage',
        component: () => import('../views/matchCourse/MatchManage.vue'),
        meta: { title: '赛程管理' },
      },
    ]
  },
  {
    path: '/outsManage',
    redirect: '/outsManage/CourseManage',
    component: layout,
    children: [
      {
        path: '/outsManage',
        name: 'outsManage',
        component: () => import('../views/outsManage/CourseManage.vue'),
        meta: { title: '赛况管理' },
      },
      {
        path: '/OutsLists',
        name: 'outLists',
        component: () => import('../views/outsManage/OutsLists.vue'),
        meta: { title: '赛况管理' },
      },
    ]
  },
  {
    path: '/couponCode',
    redirect: '/couponCode/InvitationCode',
    component: layout,
    children: [
      {
        path: '/InvitationCode',
        name: 'invitationCode',
        component: () => import('../views/couponCode/InvitationCode.vue'),
        meta: { title: '邀请码' },
      },
    ]
  },
  {
    path: '/addMatch',
    redirect: '/addMatch/NewsEvent',
    component: layout,
    children: [
      {
        path: '/NewsEvent',
        name: 'newsEvent',
        component: () => import('../views/addMatch/NewsEvent.vue'),
        meta: { title: '新增赛事' },
      },
    ]
  },
  {
    path: '/sponsor',
    redirect: '/sponsor/Sponsor',
    component: layout,
    children: [
      {
        path: '/Sponsor',
        name: 'sponsor',
        component: () => import('../views/sponsor/Sponsor.vue'),
        meta: { title: '赞助商设置' },
      },
    ]
  },
  {
    path: '/poster',
    redirect: '/poster/Poster',
    component: layout,
    children: [
      {
        path: '/Poster',
        name: 'poster',
        component: () => import('../views/poster/Poster.vue'),
        meta: { title: '海报设置' },
      },
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
